import { InferSubjects, subject } from "@casl/ability";

import { GetBookingData } from "@/shared/api/generated/schemas";
import { DeepPartial, FlattenKeys } from "@/shared/utils/ts-helpers";

type BaseSubject<Data extends object = object> = Partial<
  Record<FlattenKeys<Data>, unknown>
> & {
  kind: string;
  data?: Data;
};

// Subjects:
export interface MultiLocationView extends BaseSubject {
  kind: "MultiLocationView";
}

export interface SingleLocationView extends BaseSubject<{ id: string }> {
  kind: "SingleLocationView";
}

export interface Booking extends BaseSubject<GetBookingData> {
  kind: "Booking";
}
export interface Calendar extends BaseSubject {
  kind: "Calendar";
}

export interface Product extends BaseSubject {
  kind: "Product";
}

export interface ProductCategory extends BaseSubject {
  kind: "ProductCategory";
}

export interface Employee extends BaseSubject {
  kind: "Employee";
}

export interface Customer extends BaseSubject {
  kind: "Customer";
}

export interface Location extends BaseSubject {
  kind: "Location";
}

export interface Department extends BaseSubject {
  kind: "Department";
}

export interface Report extends BaseSubject {
  kind: "Report";
}

type AppSubjects =
  | MultiLocationView
  | SingleLocationView
  | Booking
  | Calendar
  | Product
  | ProductCategory
  | Employee
  | Customer
  | Location
  | Department
  | Report;
export type Subjects = InferSubjects<AppSubjects, true> | "all";

// Helpers:
export type GetFieldsBySubjectKind<Kind extends Subjects & string> =
  keyof Extract<AppSubjects, { kind: Kind }>;

export function getSubject<Kind extends InferSubjects<AppSubjects> & string>(
  kind: Kind,
  data: DeepPartial<Pick<Extract<AppSubjects, { kind: Kind }>, "data">["data"]>,
) {
  return subject(kind, { kind, ...data });
}
